// Loading component using Digital HIG
import React from 'react';
// @ts-ignore - Digital HIG components
import DHCircularProgress from "@digital-hig/mui/CircularProgress";

// @ts-ignore - Digital HIG components
import DHTypography from "@digital-hig/mui/Typography";
// @ts-ignore - Digital HIG components
import DHBox from "@digital-hig/mui/Box";

interface LoadingProps {
  message?: string;
}

export default function Loading({ message = 'Loading...' }: LoadingProps) {
  return (
    <DHBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem'
      }}
    >
      <DHCircularProgress />
      <DHTypography 
        variant="body-copy-medium" 
        className="dhig-typography-body-copy-medium dhig-color-text-secondary"
      >
        {message}
      </DHTypography>
    </DHBox>
  );
}

